import React, { Component } from 'react';

import { connect } from 'react-redux';

import { success } from 'redux/ducks/Flash';
import {
  submitProfile,
  registrationFieldUpdate,
  resetRegistration,
} from 'redux/ducks/Registration';

import { createSession } from 'redux/ducks/Session';

import { isNumeric } from 'redux/ducks/helpers';
import PhoneInput from 'react-phone-input-2'
import 'react-phone-input-2/lib/style.css'
import validator from 'validator'

export class Profile extends Component {

  state = {
    loggingIn: false,
  };

  componentWillReceiveProps(newProps) {
    if (!newProps.role) {
      this.props.history.push('/login');
    }

    if (!this.state.signingIn && newProps.user && newProps.user.id) {
      this.setState({ signingIn: true });
      this.props.createSession({
        email: newProps.user.email,
        password: newProps.user.password,
      });
    }

    if (newProps.currentUser && newProps.currentUser.id) {
      this.props.success('Your Profile Has Been Successfully Created');
      this.props.history.push('/edit-payment');
    }
  }

  onCancel = () => {
    this.props.reset();
  };

  onFileChange = (event) => {
    const file = event.currentTarget.files[0];

    const reader = new FileReader();
    reader.addEventListener('load', () => {
      this.props.updateField('profilePic', reader.result);
    });

    reader.readAsDataURL(file);
  };

  onFieldChange = (field) => {
    return (ev: SyntheticInputEvent<HTMLInputElement>) => {
      this.props.updateField(field, ev.currentTarget.value);
    };
  };

  onPhoneNumberChange(newNumber) {
    const phoneNo = newNumber.length === 1 && newNumber.at(0) !== '1' ? `1${newNumber}` : newNumber;
    this.props.updateField('phone', phoneNo);
  }

  onSubmit = () => {
    this.props.submitProfile();
  };

  render() {
    return (
      <div className="profile">
        <h2>Create Profile</h2>
        <p>There's just a couple more quick steps to get you started.  Set up your Go4 profile below.</p>
        <form id="profileForm">
          <section>
            <input onChange={this.onFileChange} type="file" name="profilePic" className="custom-file-input" accept="image/*" />
            <img src={this.props.user.profilePic || require('styles/GenericAdd.svg')} className="profile-pic custom-file-label" alt="Profile" />
          </section>
          <div className="form-group">
            <label htmlFor="firstName">First Name</label>
            <input type="text" className="form-control" name="firstName" onChange={this.onFieldChange('firstName')} required />
          </div>
          <div className="form-group">
            <label htmlFor="lastName">Last Name</label>
            <input type="text" className="form-control" name="lastName" onChange={this.onFieldChange('lastName')} required />
          </div>
          <div className="form-group">
            <label htmlFor="companyName">Company Name</label>
            <input type="text" className="form-control" name="companyName" onChange={this.onFieldChange('companyName')} />
          </div>
          <div className="row">
            <div className="col form-group">
              <label htmlFor="phone">Phone Number</label>
              {/* <input type="tel" className="form-control" name="phone" onChange={this.onFieldChange('phone')} required minLength="10" maxLength="10" /> */}
              <PhoneInput
                name="phone"
                onlyCountries={["us"]}
                preferredCountries={["us"]}
                enableAreaCodes={false}
                autoFormat={true}
                placeholder="Enter phone number"
                country='us'
                value={this.props.user.phone}
                onChange={this.onPhoneNumberChange.bind(this)}
              />
            </div>
            <div className="col form-group">
              <label htmlFor="addressZip">Zip Code</label>
              <input type="text" className="form-control" name="addressZip" onChange={this.onFieldChange('addressZip')} required minLength="5" maxLength="5" />
            </div>
          </div>
          <div className="controls">
            <a onClick={this.onCancel}>Cancel</a>
            <button type="button" className="btn btn-danger bold-button" onClick={this.onSubmit} disabled={!this.props.canContinue}>Save and Continue</button>
          </div>
        </form>
      </div>
    );
  }
}

function formIsValid() {
  const addressZipInput = document.querySelector('input[name="addressZip"]');
  const phone = document.querySelector('input[name="phone"]');
  const companyName = document.querySelector('input[name="companyName"]');

  if (addressZipInput && (addressZipInput.value.length !== 5 || !isNumeric(addressZipInput.value))) {
    return false;
  }

  if (phone && !validator.isMobilePhone(phone.value)) {
    return false;
  }

  if (companyName && companyName.value.length === 0) {
    return false;
  }

  const form = document.querySelector('#profileForm');
  return form instanceof HTMLFormElement && form.checkValidity();
}

function mapStateToProps(state) {
  return {
    canContinue: formIsValid(),
    currentUser: state.session.currentUser,
    role: state.registration.role,
    user: state.registration.user,
  };
}

function mapDispatchToProps(dispatch) {
  return {
    createSession: (credentials) => dispatch(createSession(credentials)),
    reset: () => dispatch(resetRegistration()),
    submitProfile: () => dispatch(submitProfile()),
    success: (message) => dispatch(success(message)),
    updateField: (field, value) => dispatch(registrationFieldUpdate(field, value)),
  };
}

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(Profile);
